import {Fragment} from "react";
import classNames from "classnames";
import WithOutLocation from "./WithOutLocation";
import AddressControl from "../../../../form/AddressControl";
import React from "react";
import {connect} from "src/store";
import isEqual from "lodash-es/isEqual";
import debounce from "../../../../../utils/debounce";

export class TillBasedPos extends React.Component {

    constructor(props) {
        super(props);
        this.change = debounce((field, value) => {
            props.setFieldValue && props.setFieldValue(field, value);
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const {props} = {...this.props};
        if (prevProps.till?.id + "" !== "" + this.props.till?.id || props.getValue("pos")?.id + "" !== "" + this.props.till?.pos?.id) {
            this.change("pos", this.props.till?.pos || null);
        }
    }

    getProps = (name) => {
        const {props} = {...this.props};
        const fieldProps = props.getProps(name);
        fieldProps.disabled = true;
        return fieldProps;
    }

    render() {
        const propsTop = {...this.props};
        const {props, state, parent} = propsTop;
        const {hidden, labels, pool, operationitems} = props;
        return (hidden || []).indexOf("pos") === -1 && <Fragment>
            <div className={classNames({"col-md-3": props.values.pos, "col-md-12": !props.values.pos})}>
                <WithOutLocation {...{...propsTop, props: {...propsTop.props, getProps: this.getProps}}} />
            </div>
            {props.values.pos && props.values.pos.location &&
            <div className={"col-md-9"}>
                <div className={"row"}>
                    <AddressControl disabled={"disabled"} name="pos.location.address"
                                    value={props.values.pos.location.address} label="Cím" saveChanges={props.setFieldValue}/>
                </div>
            </div>
            }
        </Fragment>;
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(TillBasedPos);